import React, { useEffect, useState } from "react";
import TileLayer from "ol/layer/Tile";
import XYZ from "ol/source/XYZ";
import useLayerEvents from "../hooks/useLayerEvents";
import useLayerOpacity from "../hooks/useLayerOpacity";
import useLayerZIndex from "../hooks/useLayerZIndex";
import { useMapContext } from "../map/MapProvider";
import LayerContext from "./LayerContext";
/**
 * Add an XYZ layer to the map.
 */
export default function XyzLayer({ children, authKey, opacity = 1, maxZoom, minZoom, zIndex = 0, url, attributions, onPreRender, onPostRender, }) {
    const { map, view, auth } = useMapContext();
    const setLayerZIndex = useLayerZIndex(zIndex);
    const setLayerOpacity = useLayerOpacity(opacity);
    const setLayerEvents = useLayerEvents({ onPreRender, onPostRender });
    const [_layer, setLayer] = useState();
    useEffect(() => {
        const tileLoadFunction = (imageTile, src) => {
            imageTile.getImage().src =
                authKey && auth ? `${src}&${authKey}=${auth[authKey]}` : src;
        };
        const source = new XYZ({
            url: url,
            tileLoadFunction,
            attributions,
        });
        const tileLayer = new TileLayer({
            source,
            minZoom,
            maxZoom,
        });
        setLayerEvents(tileLayer);
        setLayerZIndex(tileLayer);
        setLayerOpacity(tileLayer);
        setLayer(tileLayer);
        map.addLayer(tileLayer);
        return () => {
            map.removeLayer(tileLayer);
            setLayer(undefined);
            setLayerEvents(undefined);
            setLayerZIndex(undefined);
            setLayerOpacity(undefined);
        };
    }, [
        map,
        view,
        attributions,
        auth,
        maxZoom,
        minZoom,
        authKey,
        url,
        setLayerEvents,
        setLayerZIndex,
        setLayerOpacity,
    ]);
    return (React.createElement(LayerContext.Provider, { value: { layer: _layer } }, children));
}
